module.exports = __webpack_public_path__ + "static/img/ji.c2ab47a0.png";